import { Component, Input, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { GenderPipe } from 'src/app/moov-common/pipes/gender.pipe';
import { ScoreLevels } from 'src/app/moov-common/services/utils/utils-data';

@Component({
  selector: 'app-total-energy',
  templateUrl: './total-energy.component.html',
  styleUrl: './total-energy.component.scss',
})
export class TotalEnergyComponent extends BaseComponent {
  
  // @Input() text = '';
  @Input() value: number = 0;
  @Input() isLoading = true;
  innerText = "";
  
  constructor(private readonly translate: TranslateService, private genderSerivce: GenderPipe)
  {
    super();
  }
  
  innerCircleElements: any[] = [];
  circumference: number;
  offset: number;
  progressBarColorString = '';
  valueForPresentation : number = 0;

  ngOnInit(): void {
    this.valueForPresentation = Math.round(this.value);
    this.initCircleEl();
    this.calculateProgressBarColor();
    this.calculateBarText();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.ifChanged(changes.value, () => {
      this.valueForPresentation = Math.round(this.value);
      this.calculateProgressBarColor();
      this.initCircleEl();
      this.calculateBarText();
    });
  }

  calculateBarText():void{
    let value = "";
    if (this.value < ScoreLevels.LOW){
      value = this.translate.instant('stateView.totalEnergyInnerText_low');
    }
    else if (this.value < ScoreLevels.MEDIUM){
      value = this.translate.instant('stateView.totalEnergyInnerText_medium');
    }
    else{
      value = this.translate.instant('stateView.totalEnergyInnerText_high');
    }

    this.innerText = value;
  }

  calculateProgressBarColor(): void {
    this.progressBarColorString = this.utilsService.calculateProgressBarColor(this.valueForPresentation);
  }

  initCircleEl(): void {
    // The circumference is used to set the stroke-dasharray and stroke-dashoffset properties
    // to create the outerCircle progress effect
    this.circumference = 2 * Math.PI * 16; // Assuming the radius is 16

    // Calculate the offset to show the value progress
    // The offset determines how much of the outerCircle should be filled
    // We divide by negative 100 to make the progress bar go counter-clockwise
    this.offset = this.circumference - (this.valueForPresentation / 100) * this.circumference;

    // constants
    const radius = 14; // Radius of the inner circular layer
    const startAngle = -Math.PI / 2; // Start from the top of the circle
    const totalElements = 56; // Set the number of elements (ticks and circles) in the inner circular layer
    // Calculate the number of filled elements based on the value
    const filledElements = Math.round((this.valueForPresentation / 100) * totalElements);
    const elementAngleStep = (2 * Math.PI) / totalElements; // Divide the circle into the desired number of innerCircleElements
    const tickLength = 1.4;
    const svgCenter = 18; // Center of the SVG
    const circleRadiusAdjustment = 0.5; // Adjust the circle radius to position them slightly inward
    const tickRadiusAdjustment = 0.3; // Adjust the tick inner radius to position them slightly outward
    enum ElementType {
      Tick,
      Circle,
    }

    for (let i = 0; i < totalElements; i++) {
      const angle = startAngle + i * elementAngleStep;
      // Calculate the x and y coordinates for the outer point of the element
      const x1 = 18 + radius * Math.cos(angle);
      const y1 = 18 + radius * Math.sin(angle);

      if (i % 8 === 0) {
        // Create a circle instead of a tick every 8th element
        const circleRadius = radius - circleRadiusAdjustment; // Adjust the circle radius to position them slightly inward
        // Calculate the x and y coordinates for the center of the circle
        const cx = svgCenter + circleRadius * Math.cos(angle);
        const cy = svgCenter + circleRadius * Math.sin(angle);
        const isFilled = i <= filledElements;
        // prettier-ignore
        this.innerCircleElements.push({
          cx, cy, 
          type: ElementType.Circle, isFilled
        });
      } else {
        const tickInnerRadius = radius - tickLength + tickRadiusAdjustment; // Adjust the tick inner radius to position them slightly outward
        // Calculate the x and y coordinates for the inner point of the tick
        const x2 = svgCenter + tickInnerRadius * Math.cos(angle);
        const y2 = svgCenter + tickInnerRadius * Math.sin(angle);
        const isFilled = i <= filledElements;
        // prettier-ignore
        this.innerCircleElements.push({
          x1,y1,x2,y2,
          type: ElementType.Tick, isFilled
        });
      }
    }
  }
}
